var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading && !_vm.error)?_c('div',{attrs:{"id":"loading"}},[_c('div',{staticClass:"spinner"}),_c('p',[_vm._v("正在加载聊天组件...")])]):_vm._e(),(_vm.error)?_c('div',{attrs:{"id":"error"}},[_c('p',{attrs:{"id":"error-msg"}},[_vm._v(_vm._s(_vm.error.message))]),_c('button',{on:{"click":_vm.initializeChat}},[_vm._v("重试")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }